import {getLangDir} from 'rtl-detect';
/**
 * Support for RTL languages
 * 
 * Ensures that HTML has the correct `dir` attribute based on the 
 * current locale whenever the app renders
 * 
 */
export const LangDir = ({locale}) =>  {
  document.dir = locale ? getLangDir(locale) : '';
  return null;
};
